// Les événements — culte, veillée, convention, répétition.
//
// C'est ce qui manquait le plus à une église : une communauté en ligne sert
// d'abord à se retrouver hors ligne. Un événement dit quand, où, et qui vient.
//
// Deux listes, et l'ordre compte : ce qui arrive d'abord, le passé ensuite et
// replié. Personne n'ouvre cet écran pour lire ce qui a déjà eu lieu.

import { useState } from "react";
import Store from "../../store.js";
import { editerEvenement } from "../../views/evenement-creer.js";
import { quandLisible, estPasse } from "../dates.js";
import Icone from "../Icone.jsx";
import Vide, { Chargement } from "../Vide.jsx";
import { useAbonnement } from "../hooks.js";

/** La vignette d'un événement, dans une liste. */
export function CarteEvenement({ e }) {
  const passe = estPasse(e.quand);
  const d = new Date(e.quand);

  return (
    <a className={`evenement${passe ? " est-passe" : ""}`} href={`#/evenement/${e.id}`}>
      {/* Le bloc de date se lit plus vite qu'une ligne de texte : c'est la
          première chose qu'on cherche dans une liste d'événements. */}
      <span className="evenement__date">
        <strong>{d.getDate()}</strong>
        <span>{d.toLocaleDateString("fr-FR", { month: "short" }).replace(".", "")}</span>
      </span>
      <span className="evenement__texte">
        <strong>{e.titre}</strong>
        <span className="petit texte-doux">{quandLisible(e.quand)}</span>
        {e.lieu && <span className="petit texte-doux">📍 {e.lieu}</span>}
        {e.participants > 0 && (
          <span className="petit texte-doux">
            {e.participants} participant{e.participants > 1 ? "s" : ""}
          </span>
        )}
      </span>
      {e.image && <span className="evenement__affiche" style={{ backgroundImage: `url('${e.image}')` }} />}
    </a>
  );
}

export default function Evenements({ ctx }) {
  const tous = useAbonnement((cb) => Store.evenements.subscribe(cb), null, []);
  const [voirPasses, setVoirPasses] = useState(false);

  if (tous === null)
    return (
      <div className="colonne">
        <Chargement texte="Chargement des événements…" />
      </div>
    );

  const aVenir = tous.filter((e) => !estPasse(e.quand));
  const passes = tous.filter((e) => estPasse(e.quand)).reverse(); // le plus récent d'abord

  return (
    <div className="colonne">
      <div className="entete-page">
        <h1 className="titre-page">Événements</h1>
        <button
          className="btn btn--primaire btn--petit"
          onClick={() => editerEvenement(ctx)}
        >
          <Icone nom="plus" taille={16} /> Créer
        </button>
      </div>

      <h2 className="titre-section">À venir</h2>
      {aVenir.length ? (
        <div className="liste-evenements">
          {aVenir.map((e) => (
            <CarteEvenement e={e} key={e.id} />
          ))}
        </div>
      ) : (
        <Vide
          symbole="🗓️"
          titre="Aucun événement à venir"
          texte="Annoncez le prochain culte, une veillée, une répétition."
        />
      )}

      {passes.length > 0 && (
        <>
          <h2 className="titre-section">
            <button className="lien-oubli" onClick={() => setVoirPasses((v) => !v)}>
              {voirPasses ? "Masquer" : "Voir"} les événements passés ({passes.length})
            </button>
          </h2>
          {voirPasses && (
            <div className="liste-evenements">
              {passes.map((e) => (
                <CarteEvenement e={e} key={e.id} />
              ))}
            </div>
          )}
        </>
      )}
    </div>
  );
}
